<template>
  <div class="member-groups">
    <div v-if="groups.length === 0" class="empty">
      This organization has no groups yet.
    </div>
    <div v-else class="group-list">
      <div v-for="group in groups" :key="group.id" class="group-row">
        <el-checkbox
          :value="isMember(group.id)"
          :disabled="!!pending[group.id]"
          @change="toggle(group, $event)">
          {{ group.name }}
        </el-checkbox>
        <span v-if="group.autoEnroll" class="auto-enroll-flag">auto-enroll</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberGroupsDialog',
  props: {
    member: {
      type: Object,
      required: true
    },
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      memberGroupIds: [],
      pending: {}
    }
  },
  computed: {
    groups () {
      return this.organization.groups || []
    }
  },
  methods: {
    isMember (groupId) {
      return this.memberGroupIds.indexOf(groupId) !== -1
    },
    extractMemberGroupIds () {
      const list = this.member.groupMemberships || this.member.groups || []
      return list.map(m => {
        const g = m.organizationUserGroup || m.group || m
        return g && g.id
      }).filter(id => id)
    },
    async toggle (group, checked) {
      const organizationUserId = this.member.id
      this.$set(this.pending, group.id, true)
      try {
        if (checked) {
          await this.$http.post(
            this.$api.organization(this.$route.params.orgId).group(group.id).user(organizationUserId).add
          )
          this.memberGroupIds.push(group.id)
        } else {
          await this.$http.delete(
            this.$api.organization(this.$route.params.orgId).group(group.id).user(organizationUserId).remove
          )
          this.memberGroupIds = this.memberGroupIds.filter(id => id !== group.id)
        }
        this.$emit('refresh')
      } catch (e) {
        this.$message.error(this.errorMessage(e) || 'Could not update group membership')
      } finally {
        this.$delete(this.pending, group.id)
      }
    },
    errorMessage (e) {
      if (e && e.response && e.response.data) {
        if (typeof e.response.data === 'string') return e.response.data
        if (e.response.data.message) return e.response.data.message
      }
      return null
    }
  },
  created () {
    this.memberGroupIds = this.extractMemberGroupIds()
  }
}
</script>

<style lang="scss" scoped>
  .empty {
    color: $text-light;
    font-size: 12px;
    padding: 10px 0;
  }

  .group-list {
    display: flex;
    flex-direction: column;
    padding: 5px 0;
  }

  .group-row {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid $border;

    &:last-child {
      border-bottom: none;
    }
  }

  .auto-enroll-flag {
    margin-left: 10px;
    font-size: 11px;
    color: $text-light;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Members/MemberGroupsDialog.vue